import * as R from 'ramda'
import { of } from 'rxjs'
import { delayWhen, distinctUntilChanged, filter, ignoreElements, tap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { LOCATION_CHANGE } from 'connected-react-router'
import { track } from 'tracking/mixPanel'
import * as Actions from 'store/actions/index.ts'
import { isSaleHomePageAction } from 'domain/router'
import {
  getDaysSinceStartSale,
  getNormalizedNbSubUniversesInCatalog,
  getNormalizedNbUniversesInCatalog,
  getOperationCode,
  getProductsInParentScope,
  getSaleResource,
  getSaleStartTime
} from 'store/selectors'
import { disableMixPanelTracking } from '../disable'

export const mapStateToMPEvent = (eventName, state) => ({
  '# of References': getProductsInParentScope(state).length,
  '# of Sub Universes': getNormalizedNbSubUniversesInCatalog(state),
  '# of Universes': getNormalizedNbUniversesInCatalog(state),
  'Days Since Sale Start': getDaysSinceStartSale(state),
  'Event Name': eventName,
  'Operation Code': getOperationCode(state),
  'Sale Start Time': getSaleStartTime(state)
})

const viewSaleHomePageEpic = (actions$, state$) => actions$.pipe(
  disableMixPanelTracking(actions$),
  ofType(LOCATION_CHANGE),
  distinctUntilChanged(R.eqBy(R.path(['payload', 'location', 'pathname']))),
  filter(isSaleHomePageAction),
  delayWhen(() => (getSaleResource(state$.value))
    ? of({})
    : actions$.pipe(
      ofType(Actions.resources.RESOURCE_FETCHED),
      filter(({ payload: { type } }) => (type === 'sale'))
    )
  ),
  tap(() => {
    const eventName = 'View Sale Homepage'

    track(eventName, mapStateToMPEvent(eventName, state$.value), { debug: !__PRODUCTION__ })
  }),
  ignoreElements()
)

export default viewSaleHomePageEpic
